import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {Button, ButtonGroup, Col, Form, Row} from "react-bootstrap";
import CpmRangeInput from "./CpmRangeInput";
import isEmpty from "lodash/isEmpty";

export default function CpmRangeTable( {onChange, value, range} ) {
  const { t } = useTranslation();
  const defaultValue = [{from: 0, to: "", value: ""}];
  const [ cpmCol, setCpmCol ] = useState(defaultValue);
  const [ cpmAddDisbaled, setCpmAddDisbaled ] = useState(true);
  const [ cpmRemoveDisbaled, setCpmRemoveDisbaled ] = useState(true);

  const cpmUpdate = function(attribute, value, index) {
    return cpmCol.map((item,i) => {
      if (index !== i) { return item }
      let newVal = { [attribute]: value }
      return { ...item, ...newVal }
    })
  };
  const isAddDisabled = function() {
    if (cpmCol.length == 0) { return true }
    if (isNaN(parseInt(cpmCol.at(-1).to)) ) { return true }
    if (parseInt(cpmCol.at(-1).to) < parseInt(cpmCol.at(-1).from)) { return true }
    return false
  };
  const isRemoveDisabled = function() {
    if (cpmCol.length <= 1) { return true }
    return false
  };
  const add = function() {
    return [...cpmCol, {from: cpmCol.at(-1).to, to:"", value: ""}]
  };
  const remove = function() {
    let newVal = { ...cpmCol.at(-2), to: "" }
    return [...cpmCol.slice(0,-2), newVal ]
  };
  const apiFormat = function() {
    let res = {};
    cpmCol.forEach(element => {
      res[element.from] = parseFloat(element.value)
    });
    return res;
  };
  const fromApiFormat = function(cpm) {
    if (!cpm || isEmpty(cpm)) { return defaultValue };
    let sortedKey = Object.keys(cpm).map((k) => parseInt(k)).sort();
    return sortedKey.map((from, i) => {
      let obj = { from: from, value: cpm[from] }
      if (i !== (sortedKey.length -1) ) {
        obj.to = cpm[sortedKey[i+1]];
      }
      return obj
    })
  }

  useEffect(() => {
    setCpmAddDisbaled(isAddDisabled());
    setCpmRemoveDisbaled(isRemoveDisabled());
    onChange(apiFormat());
  }, [cpmCol])

  useEffect(() => {
    setCpmCol(fromApiFormat(value));
  }, []);

  if (cpmCol.length == 0) return (<></>);

  return (
    <>
      { cpmCol.length > 0 &&
      <Form.Group>
        <Row>
          {range && <>
          <Col>
            <Form.Label>{t('from')}</Form.Label>
          </Col>
          <Col>
            <Form.Label>{t('to')}</Form.Label>
          </Col>
          </>}
          <Col>
            <Form.Label>{t('cpm')}</Form.Label>
          </Col>
        </Row>
        { cpmCol.map((val, i) => (
            <CpmRangeInput
              showRange={range}
              key={i}
              cpmRange={val}
              isToDisabled={ i !== (cpmCol.length - 1) }
              onValueChange={(attribute, value) => { setCpmCol(cpmUpdate(attribute, value, i )) } } />
          )
        )}
        {range && <div>
          <Button style={{marginRight: '5px'}} onClick={()=>{ setCpmCol(add())}} disabled={cpmAddDisbaled}>add</Button>
          <Button onClick={()=>{ setCpmCol(remove())}} disabled={cpmRemoveDisbaled}>remove</Button>
        </div>}
      </Form.Group>
      }
    </>)
}
